import "./InteriorRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import InteriorRemodelingHero from "./sections/InteriorRemodelingHero";
import DecisionsFactors from "./sections/DecisionsFactors";
import TimelineTriggers from "./sections/TimelineTriggers";
import RemodelingProcess from "./sections/RemodelingProcess";
import RemodelingFaq from "./sections/RemodelingFaq";
import ConsultationCta from "./sections/ConsultationCta";
import RemodelingCta from "./sections/RemodelingCta";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function InteriorRemodelingPage() {
  return <div>
      <Header />
      <InteriorRemodelingHero />
      <DecisionsFactors />
      <RemodelingCta />
      <TimelineTriggers />
      <RemodelingProcess />
      <RemodelingFaq />
      <EstimateRequestForm />
      <ConsultationCta />
      <Footer />
    </div>;
}